import React from 'react';
import styled from 'styled-components';
import {motion, useMotionValue, useTransform} from 'framer-motion';
import root from 'window-or-global';

const UniverseCards = styled.div`
    width: 100%;
    height: 50vh;
    position: fixed;
    top: 60vh;
    pointer-events: none;
    left: 0;
    z-index: 300;
`;

const Card = styled.div`
    width: 700px;
    height: 300px;
    position: fixed;
    top: 0;
    pointer-events: none;
    left: -500px;
    opacity: 0.7;
    background-size: cover;
    background-repeat: no-repeat;
    transform-origin: center;
    &.card-1 {
        background-image: url('https://cdn2.unrealengine.com/fake-card-left-1562x917-68ce07f2bd28.jpg');
    }
    &.card-2 {
        top: -250px;
        left: auto;
        right: -600px;
        background-image: url('https://cdn2.unrealengine.com/fake-card-right-1562x917-3f6f69d59f62.jpg');
    }
`;

interface HomepageFakeCardsProps {
    position: number;
}

export const HomepageFakeCards = ({position}: HomepageFakeCardsProps): JSX.Element => {
    const scrollY = useMotionValue(0);
    scrollY.set(position || 0);

    const vh = Math.max(root.innerHeight || 0);
    const scrollPoints = [vh + 100, vh, vh - 200, vh - 300];

    const slideXCard1 = useTransform(scrollY, scrollPoints, [-200, -75, 30, -200]);
    const slideXCard2 = useTransform(
        scrollY,
        [vh + 120, vh + 50, vh, vh - 200, vh - 300],
        [200, 50, -100, -80, 0]
    );

    const slideInY = useTransform(scrollY, scrollPoints, [175, 150, 100, -300]);
    const cardOpacity = useTransform(scrollY, scrollPoints, [0, 0.5, 1, 0]);
    return (
        <UniverseCards>
            <motion.div
                style={{
                    translateX: slideXCard1,
                    translateY: slideInY,
                    opacity: cardOpacity
                }}>
                <Card className="card-1" />
            </motion.div>

            <motion.div
                style={{
                    translateX: slideXCard2,
                    translateY: slideInY,
                    opacity: cardOpacity
                }}>
                <Card className="card-2" />
            </motion.div>
        </UniverseCards>
    );
};
